import { Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui/Spinner';
import { useWorkspaceApplications } from '@/lib/applications/workspace-applications';
import { useAdminConsoleAccess } from '@/lib/auth/admin-console-access';

export function LandingRoute() {
  const { isLoading, applications, hasApplication } = useWorkspaceApplications();
  const adminConsoleAccess = useAdminConsoleAccess();
  const nonAdminApplications = applications.filter((application) => application.clientId !== 'admin-bff');

  if (isLoading || adminConsoleAccess.isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner size="md" />
      </div>
    );
  }

  if (adminConsoleAccess.access.dashboard) {
    return <Navigate to="/dashboard" replace />;
  }

  if (nonAdminApplications.length > 0) {
    return <Navigate to={nonAdminApplications[0].homePath} replace />;
  }

  if (hasApplication('admin-bff')) {
    return <Navigate to="/profile" replace />;
  }

  if (applications.length > 0) {
    return <Navigate to={applications[0].homePath} replace />;
  }

  return <Navigate to="/forbidden" replace />;
}
